export function mustBeTruthy(value) {
  return !!value;
}

export function mustBeNotNull(value) {
  return value != null;
}
